import {
  Component,
  OnInit,
  Inject,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { ProcessListService } from '../../components/shared/services/process-list.service';
import { Subscription } from 'rxjs';
import {
  CancelProcessModel,
  CancelProcessInstanceResponse,
  CancelProcessAttachmentModel,
} from '../../components/shared/models/process-info.model';
import { AttachmentInfoModel } from '../../components/shared/models/attachment-info.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContentApiService } from '@alfresco/aca-shared';
import { PeopleContentService } from '@alfresco/adf-content-services';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/states/app.state';
import { SnackbarErrorAction } from '../../store/actions/app.custom-actions';

@Component({
  selector: 'aca-cancel-process-dialog',
  templateUrl: './cancel-process.dialog.html',
  styleUrls: ['./cancel-process.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CancelProcessDialogComponent implements OnInit, OnDestroy {
  processInstanceId: string;
  processTemplateName: string;
  attachments: Array<Object>;
  cancellationReason: string;
  subscriptions: Array<Subscription> = [];
  cancelProcessParamArray: Array<CancelProcessModel>;
  checkedoutAttachments: Array<CancelProcessAttachmentModel>;
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<CancelProcessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly processService: ProcessListService,
    private readonly customContentApi: ContentApiService,
    private readonly peopleContentService: PeopleContentService,
    private readonly store: Store<AppStore>
  ) {
    this.cancelProcessParamArray = [];
    this.checkedoutAttachments = [];
    this.processInstanceId = data.processInstanceId;
    this.processTemplateName = data.processTemplateName;
    this.attachments = data.attachments;
  }

  ngOnInit() {
    if (this.attachments && this.attachments.length) {
      this.isLoading = true;
      this.attachments.forEach((node: AttachmentInfoModel) => {
        if (node.sourceId) {
          this.subscriptions.push(
            this.customContentApi
              .getNodeInfo(node.sourceId.split(';')[0], {
                include: ['isLocked'],
              })
              .subscribe((data) => {
                if (data.isLocked) {
                  const lockOwner = data.properties['cm:lockOwner'];
                  this.subscriptions.push(
                    this.peopleContentService
                      .getPerson(lockOwner.id)
                      .subscribe((personInfo) => {
                        lockOwner.id = personInfo.email;
                        this.addAttachmentInfo(
                          node.name,
                          data.isLocked,
                          lockOwner
                        );
                      })
                  );
                } else {
                  this.addAttachmentInfo(node.name);
                }
              })
          );
        } else {
          this.addAttachmentInfo(node.name);
        }
      });
    }
  }

  addAttachmentInfo(
    name: string,
    isLocked = false,
    lockOwner?: { displayName: string }
  ) {
    let attachmentModel: CancelProcessAttachmentModel;
    if (isLocked) {
      attachmentModel = new CancelProcessAttachmentModel(
        name,
        isLocked,
        lockOwner
      );
    } else {
      attachmentModel = new CancelProcessAttachmentModel(name);
    }
    this.checkedoutAttachments.push(attachmentModel);
    this.isLoading =
      this.checkedoutAttachments.length !== this.attachments.length;
  }

  cancelProcess() {
    this.cancelProcessParamArray.push(
      new CancelProcessModel(
        this.processInstanceId,
        this.cancellationReason,
        this.checkedoutAttachments
      )
    );
    this.subscriptions.push(
      this.processService
        .cancelProcess(this.cancelProcessParamArray)
        .subscribe({
          next: (resultData: CancelProcessInstanceResponse) => {
            this.dialogRef.close({
              event: 'confirm',
              data: resultData.message,
            });
          },
          error: () => {
            this.store.dispatch(
              new SnackbarErrorAction('APP.MESSAGES.INFO.API_FAILURE')
            );
          },
        })
    );
  }

  close(): void {
    this.dialogRef.close({ event: 'close' });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }
}
